export function dateInputMask(newValue: string, isDayMonth: boolean){
  // Remove caracteres não numéricos da string
  const numericValue = newValue.replace(/\D/g, '');
  const lengthValue = numericValue.length;
  // Adiciona a máscara ao valor numérico
  const day = numericValue.substring(0, 2);
  const month = numericValue.substring(2, 4);
  const year = numericValue.substring(4, 8);
  // Verifica se o valor excede o comprimento máximo para o formato DD/MM/YYYY
  // const maskedValue = `${day}/${month}/${year}`.slice(0, 10);
  if((lengthValue > 2 && lengthValue <= 4) || (isDayMonth && lengthValue > 2)){
     const formattedValue = `${day}/${month}`;
     return formattedValue;
  }
  if(lengthValue > 4){
    const maskedValue = `${day}/${month}/${year}`.slice(0, 10);
    return maskedValue;
  }
  return numericValue;
}